import React from 'react';
import propTypes from 'prop-types';
import shortid from 'shortid';

import Chip from 'app/Chip/components/Chip';

import styles from './Filters.css';

/**
 * render active search filters
 * @param {object} props - props passed to this component
 * @returns {React.Component} search results
 */
const Filters = ({ clearSimpleFilters, deleteFilter, filters, storeResultPageNum }) => {
  const clearAllFilters = () => {
    filters.map(filter => deleteFilter(filter.key, filter.val));
    clearSimpleFilters();
  };

  return (
    <div className={styles.filterFlex}>
      <div className="d-flex flex-wrap">
        {filters.map(filter => (
          <Chip
            className="mx-1 mb-1"
            key={shortid.generate()}
            leftText={filter.text}
            rightText={filter.val}
            onClose={() => {
              deleteFilter(filter.key, filter.val);
              storeResultPageNum(1);
            }}
          />
        ))}
      </div>
      {filters.length >= 1 && (
        <button type="button" onClick={clearAllFilters} className={styles.clearButton}>
          clear
        </button>
      )}
    </div>
  );
};

Filters.propTypes = {
  clearSimpleFilters: propTypes.func.isRequired,
  deleteFilter: propTypes.func.isRequired,
  filters: propTypes.arrayOf(
    propTypes.shape({
      text: propTypes.string,
      key: propTypes.string,
      val: propTypes.oneOfType([propTypes.string, propTypes.array])
    })
  ).isRequired,
  storeResultPageNum: propTypes.func.isRequired
};

export default Filters;
